import { render, staticRenderFns } from "./additional-ancillaries.vue?vue&type=template&id=97b50bf0&scoped=true"
import script from "./additional-ancillaries.vue?vue&type=script&lang=js"
export * from "./additional-ancillaries.vue?vue&type=script&lang=js"
import style0 from "./additional-ancillaries.vue?vue&type=style&index=0&id=97b50bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b50bf0",
  null
  
)

export default component.exports